// Single source of truth for brand / legal metadata.
// Update here; all legal pages and the footer pick it up automatically.

export const BRAND = {
  name: 'SprynAI',
  legalName: 'SprynAI LLC',
  email: 'contact@sprynai.com',
  address: '5318 E Second St, Long Beach, CA 90803, USA',
  domain: 'sprynai.com',
  governingLaw: 'State of California, United States',
  lastUpdated: 'May 13, 2026',
} as const;
